// extracted by mini-css-extract-plugin
module.exports = {"transition":"transition-module--transition--k-uNT","title":"transition-module--title--3BzuP"};